import Capgemini from 'home/components/logos/Capgemini';
import Google from 'home/components/logos/Google';
import Ibm from 'home/components/logos/Ibm';
import MobileCapgemini from 'home/components/logos/MobileCapgemini';
import MobileGoogle from 'home/components/logos/MobileGoogle';
import MobileIbm from 'home/components/logos/MobileIbm';
import MobilePaypal from 'home/components/logos/MobilePaypal';
import MobilePeking from 'home/components/logos/MobilePeking';
import MobileCisco from 'home/components/logos/MobileCisco';
import MobileTrell from 'home/components/logos/MobileTrell';
import MobileYale from 'home/components/logos/MobileYale';
import Paypal from 'home/components/logos/Paypal';
import Peking from 'home/components/logos/Peking';
import Cisco from 'home/components/logos/Cisco';
import Trell from 'home/components/logos/Trell';
import Yale from 'home/components/logos/Yale';
import {
  FRONTEND_BOOTCAMPS_URL,
  FRONTEND_CHALLENGES_URL,
  FRONTEND_COURSES_URL,
  FRONTEND_LIVE_SESSIONS_URL,
  FRONTEND_LOGIN_URL,
  FRONTEND_NOTEBOOKS_URL,
  FRONTEND_SIGNUP_URL,
} from 'common/utils/constants';
import { AI_CHALLENGES_LANDING_PAGE } from 'business/pre-subscription/home/utils/constants';

export const enterpriseLogos = [
  {
    id: 1,
    Logo: Peking,
    altProp: 'Peking University',
  },
  {
    id: 2,
    Logo: Capgemini,
    altProp: 'Capgemini',
  },
  {
    id: 3,
    Logo: Cisco,
    altProp: 'Cisco',
  },
  {
    id: 4,
    Logo: Trell,
    altProp: 'Trell',
  },
];

export const learnersLogos = [
  {
    id: 1,
    Logo: Google,
    altProp: 'Google',
  },
  {
    id: 2,
    Logo: Paypal,
    altProp: 'Paypal',
  },
  {
    id: 3,
    Logo: Ibm,
    altProp: 'IBM',
  },
  {
    id: 4,
    Logo: Yale,
    altProp: 'Yale',
  },
];

export const mobileEnterpriseLogos = [
  {
    id: 1,
    Logo: MobilePeking,
    altProp: 'Peking University',
  },
  {
    id: 2,
    Logo: MobileCapgemini,
    altProp: 'Capgemini',
  },
  {
    id: 3,
    Logo: MobileCisco,
    altProp: 'Cisco',
  },
  {
    id: 4,
    Logo: MobileTrell,
    altProp: 'Trell',
  },
];

export const mobileLearnersLogos = [
  {
    id: 1,
    Logo: MobileGoogle,
    altProp: 'Google',
  },
  {
    id: 2,
    Logo: MobilePaypal,
    altProp: 'Paypal',
  },
  {
    id: 3,
    Logo: MobileIbm,
    altProp: 'IBM',
  },
  {
    id: 4,
    Logo: MobileYale,
    altProp: 'Yale',
  },
];

export const forIndividuals = [
  {
    id: 1,
    label: 'Courses',
    route: FRONTEND_COURSES_URL,
    isReactLink: true,
  },
  {
    id: 2,
    label: 'Challenges',
    route: FRONTEND_CHALLENGES_URL,
    isReactLink: true,
  },
  {
    id: 3,
    label: 'Notebooks',
    route: FRONTEND_NOTEBOOKS_URL,
    isReactLink: true,
  },
  {
    id: 4,
    label: 'Live Sessions',
    route: FRONTEND_LIVE_SESSIONS_URL,
    isReactLink: true,
  },
  {
    id: 5,
    label: 'Bootcamps',
    route: FRONTEND_BOOTCAMPS_URL,
    isReactLink: false,
  },
  {
    id: 6,
    label: 'Learning Paths',
    route: '/learning-paths',
    isReactLink: false,
  },
];

export const forEnterprises = [
  {
    id: 1,
    label: 'AI Marketplace',
    route: 'https://aimarketplace.co/',
    isReactLink: false,
    target: '_blank',
  },
  {
    id: 2,
    label: 'AI Challenges',
    route: AI_CHALLENGES_LANDING_PAGE,
    isReactLink: false,
    target: '_blank',
  },
];

export const loginData = [
  {
    id: 1,
    label: 'AI Marketplace',
    route: 'https://app.aimarketplace.co/accounts/login',
    isReactLink: true,
    target: '_blank',
  },
  {
    id: 2,
    label: 'AI Planet',
    route: FRONTEND_LOGIN_URL,
    isReactLink: true,
  },
];

export const signupData = [
  {
    id: 1,
    label: 'AI Marketplace',
    route: 'https://app.aimarketplace.co/accounts/signup',
    target: '_blank',
    isReactLink: true,
  },
  {
    id: 2,
    label: 'AI Planet',
    route: FRONTEND_SIGNUP_URL,
    isReactLink: true,
  },
];
